import useToastNotification from './useToastNotification'

export const useLocalStorage = (key: string) => {
  const { sendToastMessage } = useToastNotification()
  const setItem = (value: unknown) => {
    try {
      window.localStorage.setItem(key, JSON.stringify(value))
    } catch (error) {
      sendToastMessage(
        'error',
        'Something went wrong while saving data. Please refresh the page and try again.'
      )
    }
  }

  const getItem = () => {
    try {
      const item = window.localStorage.getItem(key)
      return item ? JSON.parse(item) : undefined
    } catch (error) {
      return undefined
    }
  }

  const removeItem = () => {
    try {
      window.localStorage.removeItem(key)
    } catch (error) {
      sendToastMessage(
        'error',
        'Something went wrong while parsing data. Please refresh the page and try again.'
      )
    }
  }

  return { setItem, getItem, removeItem }
}
